import SearchNominatim from 'ol-ext/control/SearchNominatim';
import Select from 'ol/interaction/Select';
import SearchFeature from 'ol-ext/control/SearchFeature';
import { miejscowosci_source } from './source.js';


export var select = new Select({
  style: null,
});

export var searchNominatim = new SearchNominatim({
  //target: $(".options").get(0),
  polygon: false,
  reverse: false,
  position: false,	// Search, with priority to geo position
  target: document.querySelector('#searchNominatim'),
  //typing: 1,
  //minLength:3,
  placeholder: "Szukaj w OSM...",
  url: "https://nominatim.openstreetmap.org/search",
});

searchNominatim.clearHistory();


function getTitle(feature) {
  var searchedTxt = feature.get('nazwa_16w') + ', powiat ' + feature.get('powiat_p');
  return (searchedTxt);
}


//Set the control grid reference
export var search = new SearchFeature({
  source: miejscowosci_source,
  //property: "nazwa_16w",
  getTitle: getTitle,
  className: "search_miejscowosci",
  title: "Szukaj w miejscowościach historycznych",
  placeholder: "Szukaj w danych...",
  maxHistory: -1,
  maxItems: 10,
  collapsed: false,
  noCollapse: true,
  autocomplete: function (s) {
    s = s.toLowerCase();
    var result = [];
    var regex = new RegExp(s.replace(/^\*/, ''), 'i');
    var features = this.source_.getFeatures();

    for (var i = 0, f; f = features[i]; i++) {
      if (regex.test(getTitle(f))) {
        result.push(f);
      }
    }

    result.sort(function (left, right) {
      return getTitle(left).toLowerCase().indexOf(s) < getTitle(right).toLowerCase().indexOf(s) ? -1 : 1;
    });

    return result;
  },
});


